import { render, staticRenderFns } from "./StatisticsPlatform.vue?vue&type=template&id=61948e84&scoped=true&"
import script from "./StatisticsPlatform.vue?vue&type=script&lang=js&"
export * from "./StatisticsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPlatform.vue?vue&type=style&index=0&id=61948e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61948e84",
  null
  
)

export default component.exports